export type EvaluationSource = 'agent-llm' | 'voice2voice';
export type ReviewStatus = 'needs-reviewing' | 'review-complete';
export interface EvaluationResult {
  group: string;
  recordIndex: number;
  metricName: string;
  score: number;
  model: string;
  explanation: string;
}
export interface EvaluationResponse {
  data: EvaluationResult[];
  count: number;
  runId: string;
}
export interface EvaluationScoreHistogramBin {
  label: string;
  count: number;
}
export interface ComplianceFinding {
  pk: string;
  sk: string;
  sourceType: string;
  customerId?: string;
  sessionId?: string;
  planNumber?: string;
  productType?: string;
  brand?: string;
  connectionId?: string;
  voiceSessionId?: string;
  chatDuration?: number;
  guardrailsMessage: boolean;
  pii: boolean;
  riskyAdvice: boolean;
  smokeFireMentionCount: number;
  engineerRequestCount: number;
  humanRequestCount: number;
  negativeSentimentCount: number;
  positiveSentimentCount: number;
  multipleInstructionsCount: number;
  analysisStatus: string;
  analysedAt?: string;
  /** Only present when the alerts API is queried with source=all. */
  source?: string;
  /** Defaults to 'needs-reviewing' server-side when never set. */
  reviewStatus?: ReviewStatus;
  reviewedBy?: string | null;
  reviewedAt?: string | null;
  /** Present when the alerts API returns the source transcript. */
  messageHistory?: unknown;
}
export interface ComplianceResponse {
  data: ComplianceFinding[];
  count: number;
  source: string;
}
export interface UpdateReviewStatusRequest {
  source: EvaluationSource;
  pk: string;
  sk: string;
  reviewStatus: ReviewStatus;
}
export interface UpdateReviewStatusResponse {
  data: ComplianceFinding;
}
export const GROUPS = ['white-goods', 'tvs', 'vacuums', 'boilers'] as const;
export const METRICS = [
  'Builtin.Correctness',
  'Builtin.Completeness',
  'Builtin.Helpfulness',
  'Builtin.Faithfulness',
  'Builtin.Relevance',
  'Builtin.Readability',
  'Builtin.ProfessionalStyleAndTone',
  'Builtin.Harmfulness',
  'Builtin.Stereotyping',
  'Builtin.Refusal',
] as const;
export interface TranscriptAnalysisRun {
  pk?: string;
  sk?: string;
  sourceType?: string;
  customerId?: string;
  sessionId?: string;
  planNumber?: string;
  productType?: string;
  brand?: string;
  analysisStatus?: string;
  analysedAt?: string;
  pii?: boolean;
  riskyAdvice?: boolean;
  guardrailsMessage?: boolean;
  smokeFireMentionCount?: number;
  engineerRequestCount?: number;
  humanRequestCount?: number;
  negativeSentimentCount?: number;
  positiveSentimentCount?: number;
  multipleInstructionsCount?: number;
}
export interface TranscriptAnalysisRunsResponse {
  data: TranscriptAnalysisRun[];
  count: number;
  source: EvaluationSource;
  days: number;
}
export interface EvaluationRun {
  runId: string;
  source: string;
  status: string;
  periodStart?: string;
  periodEnd?: string;
  sourceCount?: number;
  includeBoilers?: boolean;
}
export interface EvaluationRunsResponse {
  data: EvaluationRun[];
  count?: number;
  source?: string;
  days?: number;
}
